module.exports = __webpack_public_path__ + "img/flag_id.5d48f488.png";